export default {
    one: 'Food',
    add: 'Create food',
    noEditSystem: 'You cannot edit system\'s foods.',
    editingSystem: 'WARNING! Editing a system food.',
    name: 'Name',
    category: 'Category',
    chooseCategoryError: 'Please select a category',
    measure: 'Measurement unit',
    chooseType: 'Choose food type',
    attributes: {
        choose: 'Select attributes',
        isVeganQ: 'Is it vegan?',
        isFastingQ: 'Is it suitable for fasting?'
    },
    loading: 'Loading...',
    noFoods: 'No foods found.',
    noMoreFoods: 'No more foods.',
    empty: {
        noMatch: 'No foods found',
        list: 'This list has no foods',
        listText: 'Pick another list from the “List” filter.',
        mine: {
            title: 'No foods of your own yet',
            subtitle: 'Foods you create will show up here.'
        }
    },
    wrongQuantity: 'Please select a correct quantity for the food.',
    trixopoulouContent: 'Recipe details',
    noTrixopoulouContent: 'We couldn\'t find the recipe\'s details!',
    lists: {
        '0': 'Athlisis foods',
        '1': 'Trixopoulou (micronutrients)',
        '2': 'USDA',
        '3': 'Recipes',
        '4': 'My foods',
        '5': 'aCloud',
        '10': 'Supermarket',
        favourites: 'Favourite foods'
    },
    servingShort: 'serv.',
    packSizeTooltip: 'Pack size',
    servingSizeTooltip: 'Serving size as printed on the label',
    categories: {
        fresh: 'Fresh foods',
        carb: 'Carb-based',
        fat: 'Fat-based',
        protein: 'Protein-based',
        complex: 'Complex',
    },
    stats: {
        macros: 'Macronutrients',
        fats: 'Fats',
        fresh: 'Fresh',
        amylouxes: 'Starchy',
        animal: 'Animal',
        complex: 'Complex',
        drinks: 'Drinks / General',
        stats: 'Food statistics'
    },
    dbCategories: {
        fresh: 'Fresh',
        amylouxes: 'Starchy',
        fats: 'Fats',
        animal: 'Animal',
        complex: 'Complex foods',
        general: 'Drinks / General',
        uncategorized: 'Uncategorized',
    },
    foodTemplates: 'Food templates',
    freeTemplates: 'Free templates',
    create: 'Create new food',
    showQuantity: 'Show quantities',
    hideQuantity: 'Hide quantities',
    stepperLegacyToggle: 'Separate +/- buttons on the right (old layout)',
    foodListMacrosToggle: 'Macros in the food list',
    searchAllListsToggle: 'Search across all food lists',
    per: 'per',
    avoidedFood: 'Foods client avoids',
    likedFood: 'Foods client likes',
    shortQuestionnaire: 'Short questionnaire',
    longQuestionnaire: 'General questionnaire',
    dri: 'DRI',
    dayProgress: 'Day progress',
    mealProgress: 'Meal progress',
    carbohydrationWarning: 'Statistics have been altered to achieve carbohydration!',
    tomatoes: 'Tomatoes',
    bread: 'Bread',
    oliveOil: 'Olive oil',
    cheese: 'White Cheese',
    saturatedFatWarning: {
        exceedsLimit: 'Saturated fat exceeds recommended limit',
        withinLimit: 'Saturated fat within recommended limit',
        percentageOfCalories: '{percentage}% of total calories',
        recommendedLimit: 'Recommended: <10%',
        currentIntake: 'Current intake: {grams}g ({kcal} kcal)'
    }
}